/**
 * Consider adding a short description of the feature flag and how it
 * will be used.
 *
 * If the feature flag is no longer in use, remove it from this enum.
 */
export var FeatureFlags;
(function (FeatureFlags) {
    /* Show user groups */
    FeatureFlags["UserGroupsEnabled"] = "user-groups-enabled";
    /* Send local timezone to the warehouse session */
    FeatureFlags["EnableUserTimezones"] = "enable-user-timezones";
    /**
     * Enable dashboard comments
     */
    FeatureFlags["DashboardComments"] = "dashboard-comments-enabled";
    /**
     * Enable scheduler task that replaces custom metrics after project compile
     */
    FeatureFlags["ReplaceCustomMetricsOnCompile"] = "replace-custom-metrics-on-compile";
    /**
     * Enable the dynamic calculation of series color, when not manually set on the chart config.
     * This aims to make the colors more consistent, depending on the groups, but this could cause the opposite effect.
     * For more details, see https://github.com/lightdash/lightdash/issues/13831
     */
    FeatureFlags["CalculateSeriesColor"] = "calculate-series-color";
    /**
     * Enable the ability to write back custom bin dimensions to dbt.
     */
    FeatureFlags["WriteBackCustomBinDimensions"] = "write-back-custom-bin-dimensions";
    /**
     * Enable the ability to show the warehouse execution time and total time in the chart tile.
     */
    FeatureFlags["ShowExecutionTime"] = "show-execution-time";
    /**
     * Enable the ability to create custom visualizations with AI
     */
    FeatureFlags["AiCustomViz"] = "ai-custom-viz";
    /**
     * Use workers for async query execution
     */
    FeatureFlags["WorkerQueryExecution"] = "worker-query-execution";
    /**
     * Enable SQL pivot results conversion to PivotData format
     */
    FeatureFlags["UseSqlPivotResults"] = "use-sql-pivot-results";
    /**
     * Enable map chart type visualization
     */
    FeatureFlags["Maps"] = "maps";
    /**
     * Enable the unused content dashboard showing least viewed charts and dashboards
     */
    FeatureFlags["UnusedContentDashboard"] = "unused-content-dashboard";
    /**
     * Enable period-over-period comparisons option
     */
    FeatureFlags["PeriodOverPeriod"] = "pop";
    /**
     * Enable viewing and editing YAML source files in the Explore UI
     */
    FeatureFlags["EditYamlInUi"] = "edit-yaml-in-ui";
    /**
     * Enable nested spaces to define their own permissions as well as extending
     * their parent permissions. When disabled (default), all nested spaces
     * inherit permissions from their root space.
     */
    FeatureFlags["NestedSpacesPermissions"] = "nested-spaces-permissions";
    /**
     * Enable tree/list mode switcher in Metrics Catalog
     */
    FeatureFlags["MetricsCatalogTreeModeSwitcher"] = "metrics-catalog-tree-mode-switcher";
})(FeatureFlags || (FeatureFlags = {}));
export function isFeatureFlags(value) {
    return Object.values(FeatureFlags).includes(value);
}
//# sourceMappingURL=featureFlags.js.map